import { FC } from 'react';
import Button from '../../component/button/button';
import { Trans } from 'react-i18next';
import {
  useLocation,
  useNavigate,
  Location,
  NavigateFunction,
} from 'react-router-dom';
import { route } from '../../service/router';
import { InvalidLinkProps } from './invalidLink.type';
import './invalidLink.css';
import logo from '../../assets/company_logo.png';

const InvalidLink: FC<InvalidLinkProps> = () => {
  const navigate: NavigateFunction = useNavigate();

  const location: Location = useLocation();
  const messageDesc: string | undefined = (
    location.state as { messageDesc?: string }
  )?.messageDesc;
  const handleBackToLogin = (): void => {
    navigate(route.login);
  };

  const handleForgotPassword = (): void => {
    navigate(route.forgotPassword);
  };

  //return different message base on page
  const getMessageKey = (): string => {
    switch (messageDesc) {
      case 'setPassword':
        return 'invalidPage.invalidDesc';
      case 'newPassword':
        return 'invalidPage.newPasswordInvalidDesc';
      default:
        return 'invalidPage.invalidDesc';
    }
  };

  return (
    <div className="invalid-link-container">
      <div className="invalid-link-card-container">
        <img
          src={
            process.env.REACT_APP_S3_BUCKET_URL
              ? `${process.env.REACT_APP_S3_BUCKET_URL}/assets/logo.png`
              : logo
          }
          alt="Logo"
          className="mx-auto mb-6 h-16"
        />

        <div className="invalid-desc">
          <Trans i18nKey={getMessageKey()} />
        </div>
        <Button className="login-button" onClick={handleForgotPassword}>
          <Trans i18nKey="forgotPassword.forgotText" />
        </Button>

        <Button className="login-button mt-5" onClick={handleBackToLogin}>
          <Trans i18nKey="invalidPage.backToLogin" />
        </Button>
      </div>
    </div>
  );
};

export default InvalidLink;
